export default "__VITE_ASSET__sG5HoKYz__"